export const ATTENDANCE_REQUEST = "ATTENDANCE_REQUEST";
export const ATTENDANCE_SUCCESS = "ATTENDANCE_SUCCESS";
export const ATTENDANCE_FAIL = "ATTENDANCE_FAIL";

export const GET_LOAD_BA_ATTENDANCE_SUCCESS = "GET_LOAD_BA_ATTENDANCE_SUCCESS";
export const GET_LOAD_BA_ATTENDANCE_REQUEST = "GET_LOAD_BA_ATTENDANCE_REQUEST";
export const GET_LOAD_BA_ATTENDANCE_FAIL = "GET_LOAD_BA_ATTENDANCE_FAIL";

export const GET_ABSENT_EMPLOYEES_REQUEST = "GET_ABSENT_EMPLOYEES_REQUEST";
export const GET_ABSENT_EMPLOYEES_SUCCESS = "GET_ABSENT_EMPLOYEES_SUCCESS";
export const GET_ABSENT_EMPLOYEES_FAIL = "GET_ABSENT_EMPLOYEES_FAIL";